import { useEffect, useState } from "react";
import FileSaver from "file-saver";
import {
  PostCallWithErrorResponse,
  simpleGetCallWithToken,
} from "../../../api/ApiServices";
import ApiConfig from "../../../api/ApiConfig";

const MONTHS = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

export const useAddEmployeeAttendance = () => {
  const [branchList, setBranchList] = useState([]);
  const [yearList, setYearList] = useState([]);
  const [excelLoading, setExcelLoading] = useState(false);
  const [addBrData, setAddBrData] = useState({
    Month: 0,
    Year: 0,
    LocationId: 0,
  });

  const fetchLocationName = () => {
    simpleGetCallWithToken(ApiConfig.GET_BRANCH_NAME_LIST)
      .then((res) => {
        if (res.Success === true) {
          setBranchList(res.Data);
        }
      })
      .catch(() => {});
  };

  const fetchYearList = () => {
    simpleGetCallWithToken(ApiConfig.TEAMSHEET_YEAR)
      .then((res) => {
        if (res.Success === true) {
          setYearList(res.Data);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchLocationName();
    fetchYearList();
  }, []);

  const changeData = (e) => {
    const { name, value } = e.target;
    setAddBrData((prev) => ({
      ...prev,
      [name]: Number(value),
    }));
  };

  const downloadExcel = () => {
    setExcelLoading(true);
    PostCallWithErrorResponse(
      ApiConfig.ALL_EMPLOYEE_DOWNLOAD_EXCEL,
      JSON.stringify(addBrData)
    )
      .then((res) => {
        if (res.error) {
          setExcelLoading(false);
          return;
        }
        if (res.json?.Success === true) {
          const data = res.json.Data;
          FileSaver.saveAs(
            "data:" + data.ContentType + ";base64," + data.FileContents,
            data.FileDownloadName
          );
        }
        setExcelLoading(false);
      })
      .catch(() => {
        setExcelLoading(false);
      });
  };

  return {
    branchList,
    yearList,
    months: MONTHS,
    addBrData,
    changeData,
    excelLoading,
    downloadExcel,
  };
};

export default useAddEmployeeAttendance;
